$(document).ready(function() {

  if($(window).width()<749){
    $('#product-listing h2').click(function(){
          $('#product-listing ul li').hide();
          $('ul#'+$(this).attr('rel')).find('li').show();
    });

  }  
  
$( "select" ).change(function(e) {
  var target= e.target;
  var theInputField = $(target).closest('form').find('input[name="item_name"]');
  var newValue = theInputField.attr('rel') + target.value;
  $(target).closest('form').find('input[name="item_name"]').attr('value',newValue);
});
});

$(window).load(function() {

    fitVideos();
    
});




function fitVideos() {

	// Find all YouTube videos
	var $allVideos = $(".video-frame iframe"),

	    // The element that is fluid width
	  $fluidEl = $(".video-frame");

	// When the window is resized
	// (You'll probably want to debounce this)
	$(window).resize(function() {
		// if($fluidEl.width()>=1500) return;
		// var newWidth = Math.floor(($fluidEl.width()/2));
			// var newWidth = Math.floor(($fluidEl.width()));
		// Resize all videos according to their own aspect ratio
		$allVideos.each(function() {
			
			var $el = $(this);
          	var aspectRatio = $el.data('width')/$el.data('height');
			newWidth = Math.floor($fluidEl.width());
			$el
				.width(newWidth)
				.height(Math.floor(newWidth / aspectRatio));
		});

	// Kick off one resize to fix all videos on page load
	}).resize();

}



